import React, { useState } from "react";
import { BiEditAlt } from "react-icons/bi";
import { FaCircleChevronDown, FaCircleChevronUp } from "react-icons/fa6";

import "./ReusableAccordion.css";

interface Props {
  title: string;
  children: React.ReactNode;
  logo?: string;
  onEdit?: () => void;
  defaultOpen?: boolean;
  status?: string;
  showStatus?: boolean;
}

const ReusableAccordion: React.FC<Props> = ({
  title,
  children,
  logo,
  onEdit,
  defaultOpen = false,
  status = "inactive",
  showStatus = false,
}) => {
  const EditIcon = BiEditAlt as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >;
  const DownIcon = FaCircleChevronDown as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >;
  const UpIcon = FaCircleChevronUp as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >;
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="accordion">
      <button
        type="button"
        className="accordion-header"
        aria-expanded={open}
        onClick={() => setOpen(!open)}
      >
        <div className="header-content">
          {logo && <img src={logo} alt={title} className="header-logo" />}
          <span className="header-title">{title}</span>
          {showStatus && (
            <span className={`accordian-status ${status.toLowerCase()}`}>
              {status}
            </span>
          )}
        </div>

        <div className="header-icons">
          {onEdit && (
            <button
              type="button"
              className="header-edit"
              aria-label="edit"
              onClick={(e) => {
                e.stopPropagation(); // prevent toggle
                onEdit();
              }}
            >
              <EditIcon fontSize={16} />
            </button>
          )}

          {open ? <UpIcon fontSize={24} /> : <DownIcon fontSize={24} />}
        </div>
      </button>

      {open && <div className="accordion-body">{children}</div>}
    </div>
  );
};

export default ReusableAccordion;
